import classnames from 'classnames';
import React from 'react';
import { useTransition, animated } from 'react-spring';
import backdropOverlayStyles from './backdropOverlay.module.pcss';

export const ANIMATION_DURATION = 350;

export enum OverlayType {
  LIGHT = 'light',
  DARK = 'dark'
}

export interface BackdropOverlayProps {
  handleClose: () => void;
  open: boolean;
  type?: OverlayType;
  className?: string;
}

function BackdropOverlay({
  open,
  handleClose,
  type = OverlayType.DARK,
  className
}: BackdropOverlayProps): React.ReactElement {
  const transitions = useTransition(open, null, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: ANIMATION_DURATION }
  });

  return (
    <>
      {transitions.map(
        ({ item: shouldShow, key, props }) =>
          shouldShow && (
            <animated.div
              key={key}
              style={props}
              className={classnames(backdropOverlayStyles.backdropOverlay, className, {
                [backdropOverlayStyles.light]: type === 'light'
              })}
              onClick={handleClose}
              role="presentation"
            />
          )
      )}
    </>
  );
}

export default BackdropOverlay;
